<template>
    <div class="procedureCon" >
        <div class="flowChart ft14">
          <dl class="active">
            <ul>
              <li>
                <span></span>
              </li>
              <li @click="Process(0)">
                <div>
                  <span></span>
                </div>
                <p>填写信息</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
          <dl class="active">
            <ul>
              <li>
                <span></span>
              </li>
              <li @click="Process(1)">
                <div>
                  <span></span>
                </div>
                <p>信息审核</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
          <dl>
            <ul>
              <li>
                <span></span>
              </li>
              <li>
                <div>
                  <span></span>
                </div>
                <p>支付费用</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
          <dl>
            <ul>
              <li>
                <span></span>
              </li>
              <li>
                <div >
                  <span></span>
                </div>
                <p>预约取证</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
        </div>
        <div class="procedureTab">
          <div class="message active">
            <div class="messageLeft fl">
              <h5>
                <img src="../../../../../assets/images/procedure/information_icon.png">申请信息
              </h5>
              <div class="messageCon">
                <el-form>
                  <el-form-item label="申请公证名称：">{{returnList.name}}</el-form-item>
                  <el-form-item label="包含文件数量：">{{returnList.fileAmount}}</el-form-item>
                  <el-form-item label="文件总大小：">{{returnList.fileSize}}</el-form-item>
                  <el-form-item label="公证处：">{{returnList.office}}</el-form-item>
                  <el-form-item label="公证处地址：">{{returnList.address}}</el-form-item>
                  <el-form-item label="公证书份数：">{{returnList.paperAmount}}</el-form-item>
                  <el-form-item label="公证书领取：">
                    <span v-if="returnList.receiptorType==1">本人领取</span>
                    <span v-if="returnList.receiptorType==2">其他人自然领取</span>
                    <span v-if="returnList.receiptorType==3">账号使用者领取</span>
                  </el-form-item>
                  <el-form-item label="备注：">{{returnList.remarks}}</el-form-item>
                </el-form>
              </div>
            </div>
            <div class="messageLeft fr" v-if="type==1">
              <h5>
                <img src="../../../../../assets/images/procedure/contact_icon.png">联系信息
              </h5>
              <div class="messageCon">
                <el-form>
                  <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
                  <el-form-item label="身份证：">{{returnList.userIdCard}}</el-form-item>
                  <el-form-item label="户口所在地：">{{returnList.userDomicile}}</el-form-item>
                  <el-form-item label="现居住地址：">{{returnList.userAddress}}</el-form-item>
                  <el-form-item label="领取人姓名：">{{returnList.receiptor}}</el-form-item>
                  <el-form-item label="领取人身份证：">{{returnList.receiptorIdCard}}</el-form-item>
                  <el-form-item label="领取人手机号：">{{returnList.receiptorMobile}}</el-form-item>
                  <el-form-item label="领取人邮箱：">{{returnList.receiptorMail}}</el-form-item>
                </el-form>
              </div>
            </div>
            <div class="messageLeft fr" v-if="type==2">
              <h5>
                <img src="../../../../../assets/images/procedure/contact_icon.png">联系信息
              </h5>
              <div class="messageCon">
                <el-form v-if="returnList.receiptorType==1">
                  <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
                  <el-form-item label="营业执照注册号：">{{returnList.userIdCard}}</el-form-item>
                  <el-form-item label="公司所在地：">{{returnList.userAddress}}</el-form-item>
                  <el-form-item label="领取人姓名：">{{returnList.legalPersonName}}</el-form-item>
                  <el-form-item label="领取人身份证：">{{returnList.legalPersonIdcardNumber}}</el-form-item>
                  <el-form-item label="领取人手机号：">{{returnList.receiptorMobile}}</el-form-item>
                  <el-form-item label="领取人邮箱：">{{returnList.receiptorMail}}</el-form-item>
                </el-form>
                <el-form v-if="returnList.receiptorType==2">
                  <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
                  <el-form-item label="营业执照注册号：">{{returnList.userIdCard}}</el-form-item>
                  <el-form-item label="公司所在地：">{{returnList.userAddress}}</el-form-item>
                  <el-form-item label="领取人姓名：">{{returnList.receiptor}}</el-form-item>
                  <el-form-item label="领取人身份证：">{{returnList.receiptorIdCard}}</el-form-item>
                  <el-form-item label="领取人手机号：">{{returnList.receiptorMobile}}</el-form-item>
                  <el-form-item label="领取人邮箱：">{{returnList.receiptorMail}}</el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="message">
            <div class="messageStatus">
             <h5>
                <img src="../../../../../assets/images/procedure/audit_icon.png">审核状态
              </h5>
              <div class="messageCon">
                <img src="../../../../../assets/images/service/submitted_icon.png">
                <p>您的申请信息已提交公证处审核，预计在1个工作日内会将审核结果通过短信发送到您的手机上，请注意查收。在此期间如您有疑问可联系客服电话：010-86208510</p>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import {mapState, mapGetters} from "vuex";
export default {
  data(){
    return{
      id:'',
      returnList:{},
      type:1,
      tableData: [{
        code: "",
        office: "",
        userRegisterName: "",
        fileSize: "",
        applier: "",
        receiptor: "",
        paperAmount: ""
      }],
    }
  },
  computed:{
      ...mapState(['currentInfo','userInfo']),
  },
  mounted(){
     this.returnList = JSON.parse(sessionStorage.getItem("procedure"));
     this.tableData[0].code = this.returnList.code;
    this.tableData[0].office = this.returnList.office;
    this.tableData[0].userRegisterName = this.returnList.userRegisterName;
    this.tableData[0].fileSize = this.returnList.fileSize;
    this.tableData[0].applier = this.returnList.applier;
    this.tableData[0].receiptor = this.returnList.receiptor;
    this.tableData[0].paperAmount = this.returnList.paperAmount;
     this.money = this.returnList.cost;
     this.id=this.$route.query.id;
     this.Process(1);
  },
  methods:{
    Process(num) {
      console.log(num);
      $(".message").removeClass("active");
      $(".message")
        .eq(num)
        .addClass("active");
    },
  },
    created() {
     BaseApi.createRpcToken("/user/v2/getUserInfo")
      .then(data => {
          let userArr=[...[data.datas.person],...data.datas.enterpriseList];
          let curInfo=userArr.filter(item=>item.userId==data.datas.currentUserId)[0];
           this.type=curInfo.realNameType
      })
      .catch(function(e) {
        errorLog(e);
      });
    // this.type = JSON.parse(sessionStorage.getItem("userInfo")).realNameType;
  },
   watch:{
    "currentInfo"(data){
      this.$router.replace("/personal/serviceHome")
    }
  }
}
</script>
<style lang="scss">
.procedureCon {
      margin-top: 20px;
      .flowChart {
        width: 100%;
        padding-top: 40px;
        padding-bottom: 43px;
        overflow: hidden;
        height: 50px;
        li {
          float: left;
          height: 20px;
        }
        li:nth-child(2n-1) {
          position: relative;
          width: calc((100% - 112px) / 8);
          span {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -1px;
            display: inline-block;
            width: 100%;
            height: 2px;
            background: #fbeceb;
            border-radius: 3px;
          }
        }
        dl.active {
          li:nth-child(2n-1) {
            span {
              background: #e98880;
            }
          }
          li:nth-child(2) {
            cursor: pointer;
            div {
              width: 20px;
              height: 20px;
              background: #fbeceb;
              border: 1px solid #e88078;
              border-radius: 50%;
              padding: 4px;
              box-sizing: border-box;
              margin: 0 4px;
            }
            span {
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #e88078;
            }
          }
        }
        li:nth-child(2n) {
          position: relative;
          div {
            width: 20px;
            height: 20px;
            background: #fbeceb;
            border: 1px solid #fbeceb;
            border-radius: 50%;
            padding: 2px;
            box-sizing: border-box;
            margin: 0 4px;
          }
          p {
            position: absolute;
            width: 84px;
            color: #505050;
            top: 31px;
            left: -26px;
            text-align: center;
          }
        }
        .select {
          span {
            background: #e98880 !important;
          }
        }
      }
    }
</style>
